import { formatPrice } from '../../../../../shared/js/formatters'
import { adjustLabelForOptionality } from './option-label'
import React, { useEffect, useRef } from 'react'
import type { ProductOptionWithNameProps } from '../../../../../shared/js/Module'
import type { ChangeEvent, ReactNode } from 'react'

const Select = ({
  children,
  details,
  disabled,
  id,
  label,
  name,
  onChange,
  onSubmit,
  required,
  triggerFocus,
  values,
  valid,
}: ProductOptionWithNameProps) => {
  const selectedValue = values.find(({ selected }) => selected)?.id
  const descriptionId = details ? `description-input-${id}` : null
  const ariaDescribedBy = descriptionId
    ? { 'aria-describedby': descriptionId }
    : {}
  const fieldRef = useRef<HTMLSelectElement>(null)
  const key = `select-${id}`

  let finalLabel: ReactNode = label
  if (!required) {
    finalLabel = adjustLabelForOptionality(label)
  }

  // When autofocus is expected, trigger it,
  // then move smoothly into view
  useEffect(() => {
    if (fieldRef.current && triggerFocus) {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' })
      fieldRef.current.focus({ preventScroll: true })
    }
  }, [triggerFocus])

  return (
    <>
      <label className='c-label' htmlFor={key}>
        {finalLabel}
      </label>
      <select
        aria-invalid={!valid}
        defaultValue={selectedValue}
        disabled={disabled}
        name={name}
        onChange={handleChange}
        id={key}
        ref={fieldRef}
        className='select'
        {...ariaDescribedBy}
      >
        {values.map(
          ({
            cents,
            id: valueId,
            label: valueLabel,
            cssColor,
            sparklingColor,
          }) => (
            <option
              key={valueId}
              value={valueId}
              className={`${cssColor ? 'c-option--color' : ''}${sparklingColor ? ' c-option--color-sparkling' : ''}`}
              // style={cssColor ? { backgroundColor: cssColor } : {}}
            >
              {valueLabel}
              {cents > 0 && ` (+${formatPrice(cents)})`}
            </option>
          )
        )}
      </select>
      {/* {!valid && (
        <p className='c-message c-message--help'>
          Vous devez choisir une valeur
        </p>
      )} */}
      {descriptionId && (
        <p id={descriptionId} className='c-message c-message--help'>
          {details}
        </p>
      )}

      {children}
    </>
  )

  function handleChange({
    target: { value: selectedId },
  }: ChangeEvent<HTMLSelectElement>) {
    const updatedValues = values.map((value) => {
      const selected = value.id === Number(selectedId)
      return { ...value, selected }
    })
    onChange?.(id, updatedValues, onSubmit)
  }
}

export default Select
